import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import AiChatbot from "@/pages/ai-chatbot/ai-chatbot";

export const AiChatbotDialog = () => {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <img
                    alt="Ask Ken"
                    className="z-50 mr-1 block size-8 cursor-pointer rounded-full transition-all"
                    src="/images/ken.png"
                />
            </DialogTrigger>
            <DialogContent className="w-175 max-w-full">
                <DialogHeader>
                    <DialogTitle className="gap-default flex">
                        <span>Ask Ken</span>
                        <img
                            alt=""
                            className="block size-10 rounded-full"
                            src="/images/ken.png"
                        />
                    </DialogTitle>
                </DialogHeader>
                <AiChatbot />
            </DialogContent>
        </Dialog>
    );
};
